module.exports = __webpack_public_path__ + "media/images/riders/small/THOMAS_LITSCHER-f91964f71c434433d4eb008ec43f513b.png";